import * as React from 'react'
import { cva } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const pageContentVariants = cva('flex flex-col gap-6')

export interface PageContentProps extends React.HTMLAttributes<HTMLDivElement> { }

export const PageContent = React.forwardRef<HTMLDivElement, PageContentProps>(
  ({ className, ...props }, ref) => (
    <section ref={ref} className={cn(pageContentVariants(), className)} {...props} />
  ),
)
PageContent.displayName = 'PageContent'
